export default "__VITE_ASSET__5fd3c4b3__"